import { __assign, __spreadArrays } from "tslib";
import isEqual from 'lodash/isEqual';
import uniqWith from 'lodash/uniqWith';
/**
 * fixAtomicBlockText
 * @description sets whitespace as atomic block text
 */
export var fixAtomicBlockText = function (block) {
    return block.type === 'atomic' ? __assign(__assign({}, block), { text: ' ' }) : block;
};
/**
 * addInlineStyleRanges
 * @description ensures that block.inlineStyleRanges is defined ([] by default)
 */
export var addInlineStyleRanges = function (block) { return (__assign(__assign({}, block), { inlineStyleRanges: block.inlineStyleRanges || [] })); };
/**
 * fixLinkUnderlineRange
 * @description adds underline inline style ranges to links
 */
export var addLinkUnderlineRange = function (block, range) {
    var inlineStyleRange = {
        offset: range.offset,
        length: range.length,
        style: 'UNDERLINE',
    };
    var inlineStyleRanges = uniqWith(__spreadArrays((block.inlineStyleRanges || []), [inlineStyleRange]), isEqual);
    return __assign(__assign({}, block), { inlineStyleRanges: inlineStyleRanges });
};
//# sourceMappingURL=block-processors.js.map